import { GTMEvent } from '~/lib/gtm/declarations'

export const adaptStoreFinder = (location: string) => {
  return {
    event: GTMEvent.STORE_FINDER,
    location,
  }
}
